import React from 'react';
import axios from 'axios';
import { Alert, Button, Card, Collapse, List, Modal, Spin, Tag, message } from 'antd';
import { CheckCircleOutlined, LoadingOutlined, PlayCircleOutlined, ReloadOutlined, SettingOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn';

var CryptoJS = require('crypto-js');

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 32 }} spin />;
var sacco = '';

class BasicSystemSetupPanel extends React.Component {
  state = {
    loading: true,
    running: false,
    setupStatus: null,
    lastResult: null,
  };

  componentDidMount() {
    if (localStorage.getItem('sacco')) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
    }
    this.loadStatus();
  }

  loadStatus = () => {
    this.setState({ loading: true });
    const form_data = new FormData();
    form_data.append('sacco', sacco);

    axios
      .post(`${serverconfig.backendserverurl}/customqueries/get_basic_system_setup_status`, form_data)
      .then((res) => {
        this.setState({ setupStatus: res.data, loading: false });
      })
      .catch(() => {
        message.error('Could not load setup status.');
        this.setState({ loading: false });
      });
  };

  runSetup = () => {
    Modal.confirm({
      title: 'Run basic system setup?',
      content: (
        <div>
          <p>This creates missing reference data only. Existing records are left unchanged.</p>
          <ul>
            <li>Member types (Ordinary, Group)</li>
            <li>ID types, UGX currency, districts</li>
            <li>Chart of account categories and core ledger accounts</li>
            <li>Default BUSINESS LOAN type wired to CASH / LOAN / SAVINGS accounts</li>
            <li>Sacco deposit/withdraw account links and feature flags</li>
          </ul>
        </div>
      ),
      okText: 'Yes, run setup',
      cancelText: 'Cancel',
      onOk: () => {
        this.setState({ running: true });
        const form_data = new FormData();
        form_data.append('sacco', sacco);

        return axios
          .post(`${serverconfig.backendserverurl}/customqueries/run_basic_system_setup`, form_data)
          .then((res) => {
            message.success(res.data.message);
            this.setState({
              lastResult: res.data,
              setupStatus: res.data.summary.status,
              running: false,
            });
          })
          .catch(() => {
            message.error('Setup failed.');
            this.setState({ running: false });
          });
      },
    });
  };

  renderChecklist() {
    const { setupStatus } = this.state;
    return (
      <List
        size="small"
        bordered
        dataSource={setupStatus?.checks || []}
        renderItem={(item) => (
          <List.Item>
            <span>{item.label}</span>
            <span>
              {item.ok ? (
                <Tag icon={<CheckCircleOutlined />} color="success">
                  {item.count}/{item.minimum}
                </Tag>
              ) : (
                <Tag color="warning">
                  {item.count}/{item.minimum}
                </Tag>
              )}
            </span>
          </List.Item>
        )}
      />
    );
  }

  render() {
    const { loading, running, setupStatus } = this.state;
    const { showChecklistExpanded = true } = this.props;

    if (loading) {
      return (
        <Card style={{ marginBottom: 16 }}>
          <div style={{ textAlign: 'center', padding: 24 }}>
            <Spin indicator={antIcon} />
          </div>
        </Card>
      );
    }

    const ready = setupStatus?.ready;
    const passedCount = (setupStatus?.checks || []).filter((c) => c.ok).length;
    const totalCount = (setupStatus?.checks || []).length;

    return (
      <Card style={{ marginBottom: 16 }}>
        <Alert
          type={ready ? 'success' : 'warning'}
          showIcon
          message={
            ready
              ? 'System reference data is ready. You can proceed to data imports.'
              : 'Quick setup needed — click the button below to create missing reference data automatically.'
          }
          description={!ready ? `${passedCount}/${totalCount} setup checks passed.` : null}
          style={{ marginBottom: 16 }}
        />

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            alignItems: 'center',
            marginBottom: showChecklistExpanded ? 16 : 0,
          }}
        >
          <Button
            type="primary"
            size="large"
            icon={<SettingOutlined />}
            loading={running}
            onClick={this.runSetup}
          >
            Run Basic System Setup
          </Button>
          <Button icon={<ReloadOutlined />} onClick={this.loadStatus} disabled={running}>
            Refresh status
          </Button>
          {ready && (
            <Tag color="success" style={{ fontSize: 14, padding: '4px 10px' }}>
              Ready
            </Tag>
          )}
        </div>

        {showChecklistExpanded && (
          <Collapse ghost defaultActiveKey={ready ? [] : ['checklist']}>
            <Panel header="View setup checklist" key="checklist">
              {this.renderChecklist()}
            </Panel>
          </Collapse>
        )}
      </Card>
    );
  }
}

export default BasicSystemSetupPanel;
